export const BANNER_IMG =
  "https://dev.api.adnoc.ae/onehub-sitecore-uat/onehub/-/media/OneHub/News/Unlock-the-power-of-your-ideas/article-banner_small.ashx";
